<template>
  <v-layout column>
    <v-layout column justify-space-between v-if="!step.validated">
      <uploader v-on:s3url="upload($event)" :fileName="selectedFileName()" onlyPdf displayName="Drop PDF files here or <span class='filepond--label-action'>Browse</span>"/>

      <span v-if="filePresent">
        <v-icon small class="pr-2" color="primary">mdi-cloud-upload</v-icon>
        <a :href="`${s3bucket}/${step.file_upload_url}`" target="_blank">{{
          step.file_upload_url
        }}</a>
      </span>
    </v-layout>
    <v-layout row justify-space-between v-else>
      <v-flex xs12 style="height: inherit;" v-if="filePresent">
        <filePreviewer
          height="500"
          :filename="step.file_upload_url"
          :url="s3bucket + '/' + step.file_upload_url"
          v-if="filePresent"
        />
      </v-flex>
      <v-flex v-else class="pa-4 text-xs-center" xs12>
        <v-icon color="primary" small class="pr-2">info</v-icon> This step was
        validated without any file uploaded.</v-flex
      >
    </v-layout>
  </v-layout>
</template>

<script>
import uploader from "../shared/uploader";
import SEND_STEP_URL_FILE from "../../graphql/steps/send_step_url_file.gql";
import date from "../../mixins/date.js";
import filePreviewer from "../shared/filePreviewer";
export default {
  mixins: [date],
  components: { uploader, filePreviewer },
  props: {
    step: {
      type: Object,
      required: true,
    },
    actionDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  computed: {
    filePresent() {
      return this.step.file_upload_url && this.step.file_upload_url.length > 0;
    },
  },
  methods: {
    selectedFileName() {
      const name = this.step.step_template.pdf_template
        ? this.step.step_template.pdf_template.name
        : this.step.step_template.file_upload_label;

      const prefix = this.step.expedition
        ? this.step.expedition.contract.name.replace("/", "-") +
          "." +
          this.step.expedition.number
        : this.step.contract.name.replace("/", "-");

      return `${prefix} -- ${name}`;
    },
    upload(url) {
      const variables = {
        id: this.step.id,
        file_upload_url:
          this.selectedFileName() +
          "." +
          url.split(".")[url.split(".").length - 1],
      };
      this.sendMutation("uploaded", "file", SEND_STEP_URL_FILE, variables).then(
        (data) => {
          this.step.file_upload_url = data.update_step.file_upload_url;
          this.$emit("update:actionDone", true);
        }
      );
    },
  },
};
</script>
